import Thanks from "./Thanks"

export default function ThanksPage() {
  return (<Thanks />);
}